import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setSelectedInvoice } from 'slices/payment'
import { PaymentOptions } from './components'

export function PaymentsDrawer() {
  const { selectedInvoice } = useSelector(({ payments }) => payments)
  const { id, codeBar, value, dueDate, urlFile } = selectedInvoice || {}
  const { stage } = useSelector(({ drawer }) => drawer)
  const dispatch = useDispatch()

  useEffect(() => {
    function onClose() {
      dispatch(setSelectedInvoice(null))
    }

    return onClose
  }, [dispatch])

  return stages({ id, codeBar, value, dueDate, urlFile, isPaid: false })[stage]
}

function stages({ ...props }) {
  return {
    initial: <PaymentOptions {...props} />,
  }
}
